import { render, staticRenderFns } from "./companyData.vue?vue&type=template&id=7e72a1d2&scoped=true"
import script from "./companyData.vue?vue&type=script&lang=js"
export * from "./companyData.vue?vue&type=script&lang=js"
import style0 from "./companyData.vue?vue&type=style&index=0&id=7e72a1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e72a1d2",
  null
  
)

export default component.exports